// SSE streams are stored in S3 with a 7-day retention policy.
// These utilities help determine when an SSE stream will expire
// based on the ULID-encoded entry UUID timestamp.
const SSE_STREAM_TTL_DAYS = 7;
const SSE_STREAM_TTL_MS = SSE_STREAM_TTL_DAYS * 24 * 60 * 60 * 1000;
// Crockford's Base32 alphabet used by ULID for timestamp encoding.
const CROCKFORD_BASE32 = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
function extractTimestampFromUlid(ulid) {
    if (!ulid || ulid.length < 10) {
        return null;
    }
    const timeChars = ulid.substring(0, 10).toUpperCase();
    let timestamp = 0;
    for (const char of timeChars) {
        const index = CROCKFORD_BASE32.indexOf(char);
        if (index === -1) {
            return null;
        }
        timestamp = timestamp * 32 + index;
    }
    return timestamp;
}
/**
 * Calculates the expiration status of an SSE stream based on its entry UUID.
 * SSE streams are retained in S3 for 7 days from creation.
 */
export function getSseStreamExpiration(entryUuid) {
    const timestamp = extractTimestampFromUlid(entryUuid);
    if (!timestamp) {
        return {
            expiresAt: null,
            isExpired: false,
            daysRemaining: null,
        };
    }
    const expiresAt = new Date(timestamp + SSE_STREAM_TTL_MS);
    const now = Date.now();
    const isExpired = now > expiresAt.getTime();
    const msRemaining = expiresAt.getTime() - now;
    const daysRemaining = isExpired ? 0 : Math.ceil(msRemaining / (24 * 60 * 60 * 1000));
    return {
        expiresAt,
        isExpired,
        daysRemaining,
    };
}
//# sourceMappingURL=sseStreamExpiration.js.map